module.exports = __webpack_public_path__ + "static/img/qudi (7).06aa4a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (7).jpg
// module id = HvIY
// module chunks = 0